import { render, staticRenderFns } from "./WritingDetailEN.vue?vue&type=template&id=651de283&scoped=true&"
import script from "./WritingDetailEN.vue?vue&type=script&lang=js&"
export * from "./WritingDetailEN.vue?vue&type=script&lang=js&"
import style0 from "./WritingDetailEN.vue?vue&type=style&index=0&id=651de283&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651de283",
  null
  
)

export default component.exports